export const BATCH_PHASE_LABELS: Record<string, string> = {
  grouping: '그룹핑',
  load_sessions: '세션 로드',
  llm: 'LLM 진단',
  snapshot_write: '회차 스냅샷',
  product_snapshot: '상품 스냅샷',
  alerts: '알림 diff',
};

export const BATCH_PHASE_ORDER = [
  'grouping',
  'load_sessions',
  'llm',
  'snapshot_write',
  'product_snapshot',
  'alerts',
] as const;

export function formatSlowestPhase(phaseDurationsMs?: Record<string, number>): string {
  if (!phaseDurationsMs || !Object.keys(phaseDurationsMs).length) return '-';
  let maxPhase = '';
  let maxMs = 0;
  for (const [phase, ms] of Object.entries(phaseDurationsMs)) {
    if (ms > maxMs) {
      maxMs = ms;
      maxPhase = phase;
    }
  }
  if (!maxPhase) return '-';
  const label = BATCH_PHASE_LABELS[maxPhase] || maxPhase;
  return `${label} ${Math.round(maxMs / 1000)}s`;
}
